import React from 'react';

import { Box } from '@/shared/ui/box';
import { BodyTextBoldPrimary } from '@/shared/ui/typography';
import { useConfirmDataPrompt } from '@/features/data-managment/model/hooks';

import {
  ArrowBottomIcon,
  ArrowUpIcon,
  WalletButton,
  ClockIcon,
} from './styles';

export const WalletTabs = ({ activeTab, setCurrentStep, t }) => {
  const { role, addQueryParam } = useConfirmDataPrompt();

  const handleTabClick = React.useCallback(
    (tab) => {
      if (tab === 'withdraw' && role === 'guest') {
        addQueryParam('confirm');
        return;
      }
      setCurrentStep(tab);
    },
    [role, setCurrentStep]
  );

  return (
    <Box $display="flex" $margin="24px 0px">
      <WalletButton
        icon={<ArrowBottomIcon $active={activeTab === 'deposit'} />}
        variant={activeTab === 'deposit' ? 'orangeGradient' : 'transparent'}
        onClick={() => handleTabClick('deposit')}
        type="button"
      >
        <BodyTextBoldPrimary
          color={activeTab === 'deposit' ? '#fff' : '#AFAFAF'}
        >
          {t('wallet.tabs.deposit')}
        </BodyTextBoldPrimary>
      </WalletButton>

      <WalletButton
        icon={<ArrowUpIcon $active={activeTab === 'withdraw'} />}
        variant={activeTab === 'withdraw' ? 'orangeGradient' : 'transparent'}
        onClick={() => handleTabClick('withdraw')}
        type="button"
      >
        <BodyTextBoldPrimary
          color={activeTab === 'withdraw' ? '#fff' : '#AFAFAF'}
        >
          {t('wallet.tabs.withdraw')}
        </BodyTextBoldPrimary>
      </WalletButton>

      <WalletButton
        icon={<ClockIcon $active={activeTab === 'history'} />}
        variant={activeTab === 'history' ? 'orangeGradient' : 'transparent'}
        onClick={() => handleTabClick('history')}
        type="button"
      >
        <BodyTextBoldPrimary
          color={activeTab === 'history' ? '#fff' : '#AFAFAF'}
        >
          {t('wallet.tabs.history')}
        </BodyTextBoldPrimary>
      </WalletButton>
    </Box>
  );
};
